import { http } from './http';
import type { ApiSuccess } from './types';
import type { PermissionKey } from '@auth/types';

export interface RoleDto {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  isSystem: boolean;
  isActive: boolean;
  permissions?: Array<{ id: number; key: PermissionKey; label: string }>;
}

export const rolesApi = {
  async list(): Promise<RoleDto[]> {
    const res = await http.get<ApiSuccess<RoleDto[]>>('/api/roles');
    return res.data.data;
  },

  async create(payload: {
    name: string;
    slug: string;
    description?: string | null;
    isActive?: boolean;
  }): Promise<RoleDto> {
    const res = await http.post<ApiSuccess<RoleDto>>('/api/roles', payload);
    return res.data.data;
  },

  async update(
    id: number,
    payload: Partial<{ name: string; slug: string; description: string | null; isActive: boolean }>,
  ): Promise<RoleDto> {
    const res = await http.put<ApiSuccess<RoleDto>>(`/api/roles/${id}`, payload);
    return res.data.data;
  },

  async replacePermissions(id: number, permissionKeys: PermissionKey[]): Promise<RoleDto> {
    const res = await http.post<ApiSuccess<RoleDto>>(`/api/roles/${id}/permissions`, {
      permissionKeys,
    });
    return res.data.data;
  },

  async remove(id: number): Promise<void> {
    await http.delete(`/api/roles/${id}`);
  },
};
